import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'

import { SHIFT_MODE_VALUES } from '@/entities/shifts'
import { CreateShiftPage } from '@/pages/create-shift-page'

const createShiftSchema = z.object({
    mode: z.enum(SHIFT_MODE_VALUES).default('start'),
})
export const Route = createFileRoute('/_master-layout/_dashboard-layout/shifts/create')({
    component: CreateShiftPage,
    validateSearch: createShiftSchema,
})
